<script>
export default {
    name: 'AppFavorite',
    props: {
        attr: {type: String, required: true},
        value: {type: String, required: true},
        obj: {type: Object, required: true},
        extraCss: {type: String, default: 'float-right'},
        // Button mode (e.g. recommendation cards): render a labelled button
        // instead of the bare bookmark icon. Default keeps the icon (backward
        // compatible with the exhibitor list/detail usages).
        button: {type: Boolean, default: false},
        label: {type: String, default: 'Vormerken'},
        labelActive: {type: String, default: 'Vorgemerkt'},
    },

    data() {
        return {
            active: false,
        }
    },

    computed: {
        css() {
            let d = {fas: this.active, far: !this.active}
            d[this.extraCss] = 1
            return d
        },

        favoriteKey() {
            return `favorite_${this.attr}`
        },
        itemKey() {
            return `${this.attr}s`
        }
    },

    created() {
        this.active = this.getMarkedValues().indexOf(this.value) >= 0
    },

    methods: {
        getMarkedValues() {
            return this.$storage.getItem(this.favoriteKey, [])
        },

        onClick() {
            let values = this.getMarkedValues()
            let items = this.$storage.getItem(this.itemKey, {})
            if (this.active) {
                const idx = values.indexOf(this.value)
                values.splice(idx, 1)
                delete items[this.value]
            } else {
                values.push(this.value)
                items[this.value] = this.obj
            }
            this.active = !this.active
            this.$storage.setItem(this.favoriteKey, values)
            this.$storage.setItem(this.itemKey, items)
            if (this.$storage.getToken() && navigator.onLine) {
                this.$storage.updateRemoteFavoriteKey(this.favoriteKey, values)
            }
            this.$emit('favorite-changed', this.value)
        }
    }
}
</script>

<template>
    <button v-if="button" type="button" class="btn btn-sm"
     :class="active ? 'btn-warning' : 'btn-outline-warning'" @click.prevent="onClick">
        <i class="fa-bookmark" :class="{fas: active, far: !active}"></i>
        {{ active ? labelActive : label }}
    </button>
    <i v-else class="fa-bookmark text-warning" :class="css" @click.prevent="onClick"></i>
</template>
